/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Change_DueInputs */

const vi_payment_change_due = /** @type {(inputs: Payment_Change_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền thừa trả khách`)
};

/**

* @param {Payment_Change_DueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_change_due = /** @type {((inputs?: Payment_Change_DueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Change_DueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_change_due(inputs)
});